import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '@/shared/lib';
import { useHotkeys } from '@/shared/lib/hotkeys';

import { createMenuActions } from './actions';

export const useGlobalMenuHotkeys = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const actions = createMenuActions(dispatch, navigate);

  useHotkeys(actions, true);
};
